module.exports = __webpack_public_path__ + "assets/img/AA4-AA6.e23b05e6.png";